/**
 * 当前轻量版工具版本号。
 *
 * `APP_DISPLAY_VERSION` 只用于界面展示。
 * 显示规则：`v主版本.副版本.修订号.MMDDNNN`，其中 `NNN` 为当天编译序号。
 * 每次提交代码前需要按当前时间手动更新。
 */
export const APP_DISPLAY_VERSION = 'v1.0.0-0708001'
export const APP_VERSION = '1.0.0-0708001'
export const APP_NAME = '橙易'